"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var App_vue_1 = __importDefault(require("./App.vue"));
var element_plus_1 = __importDefault(require("element-plus"));
var pinia_1 = require("pinia");
var ElementPlusIconsVue = __importStar(require("@element-plus/icons-vue"));
var index_1 = __importDefault(require("@/directive/index"));
var router_1 = __importDefault(require("./router"));
var TableUnit_vue_1 = __importDefault(require("@/components/Table/TableUnit.vue"));
require("element-plus/dist/index.css");
require("element-plus/theme-chalk/dark/css-vars.css");
require("@/assets/style/element.less");
require("@/assets/style/common.less");
var app = (0, vue_1.createApp)(App_vue_1.default);
for (var _i = 0, _a = Object.entries(ElementPlusIconsVue); _i < _a.length; _i++) {
    var _b = _a[_i], key = _b[0], component = _b[1];
    app.component(key, component);
}
app.component("table-unit", TableUnit_vue_1.default);
var pinia = (0, pinia_1.createPinia)();
var directiveVue = new index_1.default();
directiveVue.watermark(app);
// directiveVue.demo(app) //注册多个全局指令
app.use(router_1.default).use(element_plus_1.default).use(pinia).mount('#app');
